import styled from '@emotion/styled';
import { Line } from '~/shared/components';

type StyledLineProps = {
    inView?: boolean;
    index?: number;
};

export const StyledLine = styled(Line)<StyledLineProps>(
    ({ theme: { animations }, inView = false, index = 0 }) => ({
        transitionDuration: `${animations.durations['slow02']}s`,
        transitionTimingFunction: animations.getEasing('standard', 'expressive'),
        transformOrigin: index % 2 ? 'right' : 'left',
        transform: `scaleX(${inView ? 1 : 0})`,
    })
);
